import ReactOnRails from 'react-on-rails'

import Chat from './pages/Chat'
import Checkout from './pages/Checkout'
import Profile from './pages/Profile'

import './styles'

ReactOnRails.register({
  // @ts-ignore: Incorrect interface Prop in ReactOnRails
  Checkout,
  // @ts-ignore: Incorrect interface Prop in ReactOnRails
  Chat,
  // @ts-ignore: Incorrect interface Prop in ReactOnRails
  Profile,
})
